/**
 * Deterministic per-category page metadata used by ShopAll.
 *
 * Prerender captures a snapshot BEFORE `/api/categories` returns, so we cannot
 * rely on the category document's `description` field being available.
 *
 * Every value here is hand-authored to fall in the [140, 160] character range
 * so the Bing meta-description crawler stays green.
 */
export const CATEGORY_META = {
  "growth-hormone-secretagogues": {
    name: "Growth-Hormone Secretagogues",
    description:
      "Growth-hormone secretagogue peptide reference standards including CJC-1295, Ipamorelin, and Sermorelin analogs. Lot-tracked, signature-required delivery. Research use only.",
  },
  "glp-family-analogs": {
    name: "GLP-Family Analogs",
    description:
      "GLP-1, GLP-2, and GLP-3 receptor agonist peptide reference standards for laboratory research. signature-required shipping. Research use only.",
  },
  "melanocortin-peptides": {
    name: "Melanocortin Peptides",
    description:
      "Melanocortin-receptor peptide reference standards including Melanotan I and Melanotan II. signature-required shipping. Research use only.",
  },
  "mitochondrial-peptides": {
    name: "Mitochondrial Peptides",
    description:
      "Mitochondrial-targeted peptide reference standards including MOTS-c and SS-31 (elamipretide). signature-required shipping. Research use only.",
  },
  "thymic-immune-peptides": {
    name: "Thymic & Immune Peptides",
    description:
      "Thymic and immune-modulating peptide reference standards including Thymosin Alpha-1 and Thymogen. signature-required shipping. Research use only.",
  },
  "bioregulator-peptides": {
    name: "Bioregulator Peptides",
    description:
      "Bioregulator (Khavinson) peptide reference standards including Epithalon, Pinealon, and Vilon. signature-required shipping. Research use only.",
  },
  "copper-complex-peptides": {
    name: "Copper-Complex Peptides",
    description:
      "Copper-tripeptide reference standards including GHK-Cu and AHK-Cu for laboratory research. signature-required shipping. Research use only.",
  },
  "neuropeptides": {
    name: "Neuropeptides",
    description:
      "Neuropeptide reference standards including Selank, Semax, and Cerebrolysin analogs for lab research. signature-required shipping. Research use only.",
  },
  "investigational-standards": {
    name: "Investigational Standards",
    description:
      "Investigational peptide reference standards including BPC-157, TB-500, and DSIP for lab research. signature-required shipping. Research use only.",
  },
};

/** Every valid /shop/category/<slug> the router should treat as known. */
export const KNOWN_CATEGORY_SLUGS = Object.freeze(new Set(Object.keys(CATEGORY_META)));

export const SHOP_META = {
  name: "All Research Compounds",
  description:
    "Complete catalog of laboratory peptide reference standards from Medical Peptide Store. Signature-required delivery, lot documentation available. Research use only.",
};
